import { useTranslation } from 'react-i18next';
import { CREAM, DEST_SAND, INK, MARK_DEST, MARK_DOTS, MARK_OFFSET } from './GromlyMark';

// Splash "6A · 1b Pulso". The static copy in index.html paints the first frame;
// the gs-* keyframes live there too, so this component depends on them.

const PERIOD_S = 1.68;

const DOTS = [...MARK_DOTS, MARK_DEST];
const base = { transformBox: 'fill-box', transformOrigin: 'center' } as const;

/** The same splash inside React, for full-screen waits such as the session check. */
export default function GromlySplash() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-label={t('common.loadingApp')}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-[22px] pb-[60px]"
      style={{ background: INK }}
    >
      <svg viewBox="0 0 100 100" width={112} height={112} aria-hidden="true" className="overflow-visible">
        <g transform={MARK_OFFSET}>
          {DOTS.map((d, i) => (
            <circle
              key={d.cx} {...d} fill={d === MARK_DEST ? DEST_SAND : CREAM}
              className="motion-reduce:!animate-none"
              style={{ ...base, animation: `gs-dot ${PERIOD_S}s ease-in-out ${(i * 0.16 * PERIOD_S).toFixed(2)}s infinite both` }}
            />
          ))}
          <circle
            {...MARK_DEST} fill="none" stroke={DEST_SAND} strokeWidth={1.2}
            className="motion-reduce:hidden"
            style={{ ...base, animation: `gs-ring ${PERIOD_S}s ease-out ${(0.48 * PERIOD_S).toFixed(2)}s infinite both` }}
          />
        </g>
      </svg>
      <div
        aria-hidden="true"
        className="font-serif italic font-light text-[38px] tracking-[-0.5px] motion-reduce:!animate-none"
        style={{ color: CREAM, fontVariationSettings: '"opsz" 144', animation: 'gs-word .9s cubic-bezier(.16,1,.3,1) .2s both' }}
      >
        Gromly
      </div>
    </div>
  );
}
